    
<template>
  <div></div>
</template>
<script>
//import CSS
import addGroup from "../../../static/css/addGroup.css";
import animate from "../../../static/css/animate.css";
import chatContainer from "../../../static/css/chatContainer.css";
import fakescroll from "../../../static/css/fakescroll.css";
import friendList from "../../../static/css/friendList.css";
import group from "../../../static/css/group.css";
import memberInfo from "../../../static/css/memberInfo.css";
import NCSetting from "../../../static/css/NC-Setting.css";
import reset from "../../../static/css/reset.css";
import rwd from "../../../static/css/rwd.css";
import searchResult from "../../../static/css/searchResult.css";
import style from "../../../static/css/style.css";
import toolBar from "../../../static/css/toolBar.css";

export default {
  name: "CSS",  
  // created() {
  //   import("../../../static/css/addGroup.css");
  //   import("../../../static/css/animate.css");
  //   import("../../../static/css/chatContainer.css");
  //   import("../../../static/css/fakescroll.css");
  //   import("../../../static/css/friendList.css");
  //   import("../../../static/css/group.css");
  //   import("../../../static/css/memberInfo.css");
  //   import("../../../static/css/NC-Setting.css");
  //   import("../../../static/css/reset.css");
  //   import("../../../static/css/rwd.css");
  //   import("../../../static/css/searchResult.css");
  //   import("../../../static/css/style.css");
  //   import("../../../static/css/toolBar.css");
  // },
  data() {
    return {};
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Main/CSS.vue